var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 298.667 298.667"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.667 30.187L268.48 0 149.333 119.147 30.187 0 0 30.187l119.147 119.146L0 268.48l30.187 30.187L149.333 179.52 268.48 298.667l30.187-30.187L179.52 149.333z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOTguNjY3IDI5OC42NjciPgogICAgPHBhdGggZD0iTTI5OC42NjcgMzAuMTg3TDI2OC40OCAwIDE0OS4zMzMgMTE5LjE0NyAzMC4xODcgMCAwIDMwLjE4N2wxMTkuMTQ3IDExOS4xNDZMMCAyNjguNDhsMzAuMTg3IDMwLjE4N0wxNDkuMzMzIDE3OS41MiAyNjguNDggMjk4LjY2N2wzMC4xODctMzAuMTg3TDE3OS41MiAxNDkuMzMzeiIvPgo8L3N2Zz4K";
export { SvgDelete as ReactComponent };